const getRelativeDate = (relativeDaysCount: number): string => {
  const date = new Date();
  date.setDate(date.getDate() + relativeDaysCount);
  return date.toISOString().slice(0, 10);
};

export default getRelativeDate;
